import { Box, Column } from '@tempmee/react';
import { useSelector } from 'react-redux';
import { CenteredSpinner, EmptyScreen } from '~/commonComponents';
import { fireTodayShiftViewShiftClicked } from '~/posthogs/events';
import { CalendarTodayFilterIcon } from '~/images/emptyScreenIcons';
import { FETCH_TODAY_JOBS_ACTION } from '../../../actions';
import { createLoadingSelector } from '../../../api/selectors';
import { useTable } from '../hooks/useTable';
import { ReportIncidentPopup } from './ReportIncidentPopup/ReportIncidentPopup';
import { TodayShiftCard } from './TodayShiftCard';

export const Table = ({ limit }) => {
  const { jobListScrollRef, onRowClick, onScroll, isLoadingNextPage, isLoadingFirstPage } =
    useTable({ type: 'today' });

  const jobList = useSelector((state) => state.job.todayJobs);
  const jobListToMap = limit ? jobList?.slice(0, limit) : jobList;
  const loadingSelector = createLoadingSelector([FETCH_TODAY_JOBS_ACTION]);
  const isLoading = useSelector((state) => loadingSelector(state));

  const handleCardClick = (job) => {
    fireTodayShiftViewShiftClicked();
    onRowClick(job);
  };

  if (jobListToMap.length === 0 && !isLoading) {
    return (
      <Column pb={16} data-cy="todays-shifts-empty-state">
        <EmptyScreen
          Icon={() => <CalendarTodayFilterIcon />}
          title="No professionals coming in today!"
          description="Request or re-book a professional, and we'll help you bring top dental talent to you!"
          descriptionStyle={{
            textAlign: 'center',
          }}
        />
      </Column>
    );
  }

  if (isLoadingFirstPage) {
    return <CenteredSpinner minHeight={240} />;
  }

  return (
    <Box
      ref={jobListScrollRef}
      onScroll={onScroll}
      style={{
        overflowY: limit ? 'hidden' : 'auto',
        maxHeight: '740px',
        paddingBottom: 12,
      }}
      data-cy="todays-shifts-table-container"
    >
      {/* Full page keeps the 16px card rhythm; the Dashboard's limited list stays tighter. */}
      <Column gap={limit ? 2 : 4} className="w-full max-w-2xl mx-auto" data-cy="todays-shifts-list">
        {jobListToMap.map((job) => (
          <TodayShiftCard key={job.id || job._id} job={job} onCardClick={handleCardClick} />
        ))}
      </Column>

      {isLoadingNextPage && (
        <div style={{ marginTop: 20 }}>
          <CenteredSpinner />
        </div>
      )}
      <ReportIncidentPopup />
    </Box>
  );
};
